import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { map, catchError, tap, switchMap } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';
import { sha256 } from 'js-sha256';

import { ApiHttp } from '@core/http/api.http';
import { SessionService } from '@core/services/session.service';
import { EnvironmentService } from '@environments/service/environment.service';
import Helper from '@core/helper/common.helper';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    ipAddress: string;
    headersOption: any;
    constructor(
        private apiHttp: ApiHttp,
        private router: Router,
        private sessionService: SessionService,
        private environmentService: EnvironmentService
    ) {
        // Header option
        this.headersOption = this.environmentService.getHeaderOptions();
        // Get Ip Address Pubic Location
        this.apiHttp
            .getIpAddress('/request_ip', this.headersOption)
            .subscribe((res) => {
                this.ipAddress = res.data.ip;
            });
    }

    public login(
        username: string,
        password: string,
        returnUrl = '',
        tenant: string
    ): Observable<any> {
        // Path
        const path = '/login_admin';
        return this.apiHttp
            .getIpAddress('/request_ip', this.headersOption)
            .pipe(
                map((res: any) => res.data.ip),
                switchMap((ip: string) => {
                    const unixTimeStamp = Date.now();
                    const key = sha256(password + username);
                    const secret = sha256(key + unixTimeStamp + ip);
                    const params = {
                        data: {
                            email: username,
                            password: password,
                            tenant: tenant,
                            timestamp: unixTimeStamp,
                            ip_address: ip,
                            key: key,
                            secret: secret,
                        },
                    };

                    return this.apiHttp.post(path, params, this.headersOption);
                }),
                tap((res: any) => {
                    if (res && res.data) {
                        res.data.email = username;
                        res.data.tenant = tenant;
                        this.sessionService.saveSesstion(res.data);
                        this.router.navigateByUrl(
                            returnUrl ||
                                `${
                                    this.sessionService.currentLang
                                }${this.environmentService.getLandingPage(
                                    tenant
                                )}`
                        );
                    }
                }),
                catchError(this.handleErrorAuth.bind(this))
            );
    }

    public logout(): any {
        // remove user from local storage to log user out
        const currentLang = this.sessionService.currentLang || 'en';
        this.sessionService.destroySession();
        this.router.navigate([`${currentLang}` + '/auth/login']);
    }

    // Format and handle error for auth
    public handleErrorAuth(error: any): any {
        return throwError(error);
    }

    public getUserInformation(id: string): Observable<any> {
        // PATH
        const path = '/user/' + id;

        // PARAMS
        const options = {};

        return this.apiHttp.get(path, Helper.parseParams(options)).pipe(
            map((res) => {
                if (res && res.data) {
                    return res.data;
                }
            })
        );
    }
}
